import { render, staticRenderFns } from "./page_404.vue?vue&type=template&id=3ca8e678"
import script from "./page_404.vue?vue&type=script&lang=js"
export * from "./page_404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports